'use client';

interface CategoryFilterProps {
  categories: { label: string; slug: string }[];
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) => {
  return (
    <nav aria-label='Blog category filter' className='w-full max-w-6xl mx-auto mb-8'>
      <ul className='flex flex-wrap gap-2 justify-center' role='tablist'>
        <li role='presentation'>
          <button
            role='tab'
            aria-selected={activeCategory === 'all'}
            onClick={() => onCategoryChange('all')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer ${
              activeCategory === 'all'
                ? 'bg-[#7c3aed] dark:bg-[#00E5A0] text-white dark:text-black'
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            All
          </button>
        </li>
        {categories.map(({ label, slug }) => (
          <li key={slug} role='presentation'>
            <button
              role='tab'
              aria-selected={activeCategory === slug}
              onClick={() => onCategoryChange(slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer ${
                activeCategory === slug
                  ? 'bg-[#7c3aed] dark:bg-[#00E5A0] text-white dark:text-black'
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default CategoryFilter;
